<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    {{ $t("userAccessAdd") }}
                  </h6>
                  <button
                    class="btn btn-default btn-sm float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div class="row">
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >User</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchUser"
                            return-object
                            label="username"
                            v-model="selectedUser"
                            @search="asyncSearchUser"
                          ></v-select>

                          <div v-if="errors.user_id">
                            <div
                              v-for="error in errors.user_id"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("fulfillment_code") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchWarehouse"
                            return-object
                            label="warehouse_id"
                            v-model="selectedWarehouse"
                            @search="asyncSearchWarehouse"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.warehouse_id }} - {{ option.name }}
                            </template>
                          </v-select>

                          <div v-if="errors.fulfillments">
                            <div
                              v-for="error in errors.fulfillments"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-1">
                          <button
                            class="btn btn-icon btn-sm btn-success"
                            type="button"
                            :disabled="selectedWarehouse == null"
                            @click="addWarehouse"
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">&nbsp;</div>
                        <div class="col-lg-8">
                          <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th>{{ $t("fulfillment_code") }}</th>
                                <th>{{ $t("fulfillment_name") }}</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-show="warehouseList.length <= 0">
                                <td colspan="2" style="text-align: center">
                                  <p>Empty List</p>
                                </td>
                              </tr>
                              <tr
                                v-show="warehouseList.length > 0"
                                v-for="(list, key) in warehouseList"
                                :key="key"
                              >
                                <td>{{ list.warehouse_id }}</td>
                                <td>{{ list.name }}</td>
                                <td> <button class="btn btn-danger" type="button" @click.prevent="removeRow(key)"><i class="mdi mdi-delete"></i></button> </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "UsersAdd",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      permision_role: [],
      forms: { name: "", usernmae: "" },
      fetchUser: [],
      selectedUser: null,
      warehouseList: [],
      selectedWarehouse: null,
      fetchWarehouse: [],
    };
  },
  watch: {},
  methods: {
    removeRow(key){
      this.warehouseList.splice(key,1);
    },
    loadUser() {
      const baseURI = this.$settings.endPoint + "/user";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchUser = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    asyncSearchUser(ev) {
      const baseURI = this.$settings.endPoint + "/user?username=" + ev;
      this.fetchUser = [];
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchUser = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    loadWarehouse() {
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/warehouse/index?status=active";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchWarehouse = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    asyncSearchWarehouse(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/warehouse/index?status=active&warehouse_id=" +
        ev;
      this.fetchUser = [];
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchWarehouse = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    addWarehouse() {
      if (this.selectedWarehouse) {
        var duplicate = false;
        this.warehouseList.forEach((item) => {
          if (item.warehouse_id === this.selectedWarehouse.warehouse_id) {
            duplicate = true;
            this.error("Warehouse already added");
            return;
          }
        });
        if (!duplicate) {
          this.warehouseList.push(this.selectedWarehouse);
        }
        this.selectedWarehouse = null;
      }
    },
    resetForm() {
      this.forms = {};
      this.selectedWarehouse = null;
      this.warehouseList = [];
    },

    backForm() {
      window.location.href = "/wh-monitoring/user-mapping";
    },

    submitData() {
      this.fade(true);

      // let formData = new FormData();
      // formData.append("user_id", this.selectedUser.id);
      // formData.append("fulfillments", this.warehouseList);

      let formData = {
        'user_id': this.selectedUser.id,
        'fulfillments': this.warehouseList
      };

      const baseURI = this.$settings.endPoint + "wh-monitoring-user/store";
      this.$http
        .post(baseURI, formData, { timeout: 10000 })
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            //this.resetForm();
            this.errors = [];
            //console.log(response.data.datas.user_id);
            var params = this.$onRandom(response.data.datas.wh_monitoring_user_mapping_id);
            window.location.href =
              "/wh-monitoring/user-mapping/detail/" + params + "?status=200&msg=Successfully";
            // this.success('Berhasil');
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
          this.loading();
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
          this.loading();

        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      this.companyCode = this.detailUser.company_detail.code;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission !== null &&
          permision.permission.controller == "UserWhMonitoringMappingController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadUser();
    this.loadWarehouse();
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content {
  filter: blur(5px);
  pointer-events: none;
}
</style>
